import { AxiosError } from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import { resetGetUsernameApi } from "../../services/user";

export type Props = {
  handleNext: () => void;
  username: (n: string) => void;
};

const GetUsername = (props: Props) => {
  const [username, setUsername] = useState("");

  const verifyUsername = async () => {
    if (username != "") {
      try {
        const response = await resetGetUsernameApi(username);
        if (response.status === 200) {
          props.username(username);
          props.handleNext();
        }
      } catch (e) {
        if (e instanceof AxiosError) {
          toast.error(
            "An error has occurred when resetting password. Please contact the Admin"
          );
        }
      }
    } else {
      toast.error("Input cannot be empty!");
    }
  };
  return (
    <>
       <div className="mt-20">
        <div className="flex flex-wrap">
          <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6" >
        <div className="w-full px-6 py-4 mt-6 overflow-hidden bg-white shadow-md sm:max-w-md sm:rounded-lg">
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700 undefined"
            >
              Please enter your username to search for your account.
            </label>
            <div className="flex flex-col items-start border-gray-300 ">
              <input
                type="text"
                name="username"
                autoComplete="username"
                placeholder="Username"
                onChange={(e) => setUsername(e.target.value)}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
          </div>
          <div className="flex items-center justify-center mt-4">
            <button
              type="submit"
              className="inline-flex items-center px-4 py-2 ml-4 text-xs font-semibold tracking-widest text-white uppercase transition duration-150 ease-in-out bg-gray-900 border border-transparent rounded-md active:bg-gray-900 false"
              onClick={verifyUsername}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      </div>
        </div>
    </>
  );
};

export default GetUsername;
